import {FC, PropsWithChildren} from 'react'
import {Link} from 'react-router-dom'
import ActionButton from 'jbc-front/components/ActionButton'

interface SeeMoreButtonProps {
  to: string | undefined
}

export const SeeMoreButton: FC<PropsWithChildren<SeeMoreButtonProps>> = ({to}) =>
  to ? (
    <ActionButton as={Link} to={to}>
      すべて見る
    </ActionButton>
  ) : (
    <ActionButton as="div" disabled>
      すべて見る
    </ActionButton>
  )
